import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import PrivateRoute from './helpers/privateRoute';
import Landing from './screens/landing';
import Login from './screens/login';
import Dashboard from './screens/dashboard';
import General from './screens/general';
import Links from './screens/links';
import Sections from './screens/sections';
import Users from './screens/users';
import Icons from './screens/icons';
import Banners from './screens/banners';
import ChangePassword from './screens/profile/changePassword';
import RecoverPassword from './screens/recoverPassword';
import Network from './utils/validations/network';

Network.redirectWhenExpired();

class Main extends Component {
  render () {
    return (
      <main>
        <Switch>
          <Route exact path='/' component={Landing} />
          <Route exact path='/login' component={Login} />
          <Route exact path='/recover-password' component={RecoverPassword} />
          <PrivateRoute exact path='/dashboard' component={Dashboard} />
          <PrivateRoute exact path='/general' component={General} />
          <PrivateRoute exact path='/links' component={Links} />
          <PrivateRoute exact path='/sections' component={Sections} />
          <PrivateRoute exact path='/banners' component={Banners} />
          <PrivateRoute exact path='/users' component={Users} />
          <PrivateRoute exact path='/icons' component={Icons} />
          <PrivateRoute exact path='/profile/password' component={ChangePassword} />
        </Switch>
      </main>
    )
  }
}

export default Main;


// WEBPACK FOOTER //
// ./src/app/main.js